import { apiClient } from '@/api/client';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { AppVersion, AppVersionFormData } from '@/pages/app-versions/types';
import * as React from 'react';
import { AppVersionDrawerView } from './AppVersionDrawerView';

export interface AppVersionDrawerProps {
  onFormSubmit: (formData: AppVersionFormData) => Promise<void>;
  onDeleteAppVersion: (appVersion: AppVersion) => void;
  isFormLoading: boolean;
}

export const AppVersionDrawer: React.FC<AppVersionDrawerProps> = ({
  onFormSubmit,
  onDeleteAppVersion,
  isFormLoading,
}) => {
  const { state, actions, isLoading } = useEntityDrawer<AppVersion>({
    basePath: '/app-versions',
    queryKey: queryKeys.ADMIN_APP_VERSIONS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/app-versions/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch app version');
      return response.data as AppVersion;
    },
    supportsCreate: true,
  });

  return (
    <AppVersionDrawerView
      isOpen={state.isOpen}
      appVersion={state.entity}
      mode={state.mode}
      isLoading={isLoading}
      isFormLoading={isFormLoading}
      onClose={actions.close}
      onEdit={appVersion => actions.edit(appVersion.id!)}
      onDelete={onDeleteAppVersion}
      onFormSubmit={onFormSubmit}
    />
  );
};
